import Onboarding from './components/Onboarding';
import Highlight from './components/Highlight';
import { NAME } from './constants';
import { onboardingSlice } from './slice';

export { useDeferredOnboardingCallback, useStopOnboarding } from './hooks';
export { useLessonsJourneyTrigger } from './journeys';
export { ONBOARDING_NODE_ID } from './constants';

// Export existing tutorial onboarding components
export { Onboarding, Highlight };

// Export registration onboarding types and constants
export type {
  OnboardingStep,
  Industry,
  UserOnboardingData,
  IRegistrationOnboarding,
  OnboardingFormData,
} from './types';

export {
  ONBOARDING_STEPS,
  INDUSTRIES,
  ONBOARDING_VALIDATION,
  ONBOARDING_PROGRESS_STEPS,
} from './constants';
export default { constants: { NAME }, onboardingSlice };
